/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Ref,
  Ref$inboundSchema,
  Ref$Outbound,
  Ref$outboundSchema,
} from "./ref.js";

/**
 * Defines a linear setpoint gauge that is overlaid on top of an animatic.
 */
export type LinearSetpointGaugeConfg = {
  /**
   * The setpoints of the gauge.
   */
  setpoints?: Array<Ref> | undefined;
  /**
   * Whether to show the ticks on the gauge.
   */
  showTicks?: boolean | undefined;
  /**
   * A reference to a reading or setting.
   */
  tick?: Ref | undefined;
};

/** @internal */
export const LinearSetpointGaugeConfg$inboundSchema: z.ZodType<
  LinearSetpointGaugeConfg,
  z.ZodTypeDef,
  unknown
> = z.object({
  setpoints: types.optional(z.array(Ref$inboundSchema)),
  show_ticks: types.boolean().default(false),
  tick: types.optional(Ref$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "show_ticks": "showTicks",
  });
});
/** @internal */
export type LinearSetpointGaugeConfg$Outbound = {
  setpoints?: Array<Ref$Outbound> | undefined;
  show_ticks: boolean;
  tick?: Ref$Outbound | undefined;
};

/** @internal */
export const LinearSetpointGaugeConfg$outboundSchema: z.ZodType<
  LinearSetpointGaugeConfg$Outbound,
  z.ZodTypeDef,
  LinearSetpointGaugeConfg
> = z.object({
  setpoints: z.array(Ref$outboundSchema).optional(),
  showTicks: z.boolean().default(false),
  tick: Ref$outboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    showTicks: "show_ticks",
  });
});

export function linearSetpointGaugeConfgToJSON(
  linearSetpointGaugeConfg: LinearSetpointGaugeConfg,
): string {
  return JSON.stringify(
    LinearSetpointGaugeConfg$outboundSchema.parse(linearSetpointGaugeConfg),
  );
}
export function linearSetpointGaugeConfgFromJSON(
  jsonString: string,
): SafeParseResult<LinearSetpointGaugeConfg, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LinearSetpointGaugeConfg$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LinearSetpointGaugeConfg' from JSON`,
  );
}
